import { render } from "./Count.vue?vue&type=template&id=27bd3869&scoped=true"
import script from "./Count.vue?vue&type=script&lang=js"
export * from "./Count.vue?vue&type=script&lang=js"

import "./Count.vue?vue&type=style&index=0&id=27bd3869&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Fabiano\\OneDrive\\Área de Trabalho\\Project\\campinasredesdeprotecao\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27bd3869"]])

export default __exports__